import { db } from '../../../db'
import { useGetById, useGetList, useGetQuery } from '../../../db/hooks'
import { ListResponse, TABLE_ADDRESS_GROUPS } from '../../../db/types'
import { updateDatabase } from '../../../shared/utils/syncUtil'
import { AddressGroup } from '../types'

const overrideAddressGroups = async (
  addressGroups: Array<AddressGroup>
): Promise<void> => {
  await updateDatabase(db, TABLE_ADDRESS_GROUPS, addressGroups)
}

const useGetAllAddressGroups = () =>
  useGetList<AddressGroup>(TABLE_ADDRESS_GROUPS)

const useGetAddressGroupsForNotifications = (): ListResponse<AddressGroup> => {
  return useGetQuery<AddressGroup[]>(() => {
    return db
      .table<AddressGroup>(TABLE_ADDRESS_GROUPS)
      .filter((a: AddressGroup) => a.notifications)
      .sortBy('name')
  }, [])
}

const useGetAddressGroupById = (id: string) =>
  useGetById<AddressGroup>(TABLE_ADDRESS_GROUPS, id)

export {
  overrideAddressGroups,
  useGetAddressGroupById,
  useGetAddressGroupsForNotifications,
  useGetAllAddressGroups,
}
